export default __webpack_public_path__ + "static/media/instagram-color-square.22cd5fc9.svg";